import { __assign, __rest } from "tslib";
import React from 'react';
import styles from './ImmersiveBtn.module.less';
import { Tooltip } from 'antd';
import { connect } from '@ekuaibao/mobx-store';
import { useApp as runApp } from '@ekuaibao/whispered';
import { app as api } from '@ekuaibao/whispered';
import { OutlinedEditToolOutdent } from '@hose/eui-icons';
var ImmersiveBtn = function (props) {
    var defaultClick = function () {
        var isInImmersive = props.isInImmersive;
        api.invokeService('@layout5:changeImmersive', !isInImmersive);
    };
    var click = props.click, isInImmersive = props.isInImmersive, others = __rest(props, ["click", "isInImmersive"]);
    var title = isInImmersive ? i18n.get('展示菜单') : i18n.get('收起菜单');
    var params = __assign({ placement: 'top', title: title }, others);
    var className = styles.immersivebtn_wrapper + ' immersivebtn_wrapper-forFix';
    return (React.createElement(Tooltip, __assign({}, params),
        React.createElement("div", { id: 'immersivebtn_wrapper', className: className, onClick: click || defaultClick },
            React.createElement(OutlinedEditToolOutdent, { fontSize: 20, className: "icon inImmersive " + (isInImmersive ? "unInImmersive" : "") }))));
};
export default connect(function (store) { return ({
    isInImmersive: store.states['@layout5'].isInImmersive
}); })(runApp(ImmersiveBtn));
